// src/pages/index.ts —— 四个表格页定义汇总（subs.ts 为只读版，写动作版整体替换该文件）
import { commissionsPage, spendPage, usersPage } from './lists';
import { subsPage } from './subs';
import type { AnyPage, TablePage } from './types';

export const PAGES: Readonly<Record<TablePage, AnyPage>> = { subs: subsPage, users: usersPage, spend: spendPage, commissions: commissionsPage };

export function isTablePage(p: string): p is TablePage {
  return p === 'subs' || p === 'users' || p === 'spend' || p === 'commissions';
}
